import React from 'react';
import {
  Drawer, List, ListItem, ListItemIcon, ListItemText, Box,
} from '@mui/material';
import {
  CallReceived, ContactMail, Dashboard, History, People, PlaylistAdd, Queue, Settings,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;

const menuItems = [
  { icon: <Dashboard />, route: '/admin/campaigns', text: 'Campaigns' },
  { icon: <People />, route: '/admin/contacts', text: 'Contacts' },
  { icon: <ContactMail />, route: '/admin/appeals', text: 'Appeals' },
  { icon: <History />, route: '/admin/outgoing-calls', text: 'Outgoing Calls' },
  { icon: <CallReceived />, route: '/admin/incoming-calls', text: 'Incoming Calls' },
  { icon: <Queue />, route: '/admin/queue', text: 'Queue' },
  { icon: <Settings />, route: '/admin/settings', text: 'Settings' },
  { icon: <PlaylistAdd />, route: '/admin/todo', text: 'ToDo' },
];

interface SidebarProps {
  variant: 'permanent' | 'temporary';
  open?: boolean;
  onClose?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = (props) => {
  const navigate = useNavigate();
  const handleItemClick = (route: string) => {
    navigate(route);
    if (props.variant === 'temporary' && props.onClose) props.onClose();
  };

  const drawerContent = (
    <Box sx={{ overflow: 'auto' }}>
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} onClick={() => handleItemClick(item.route)} sx={{ cursor: 'pointer' }}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Drawer
      variant={props.variant}
      open={props.variant === 'temporary' ? props.open : undefined}
      onClose={props.variant === 'temporary' ? props.onClose : undefined}
      ModalProps={props.variant === 'temporary' ? { keepMounted: true } : undefined}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          ...(props.variant === 'permanent' && {
            marginTop: '64px',
            height: 'calc(100% - 64px)',
          }),
        },
      }}
    >
      {drawerContent}
    </Drawer>
  );
};
